<template>
<v-card flat class='pa-5' >
  <v-card-title v-if='title' class='subtitle-1 overline text-h5 px-10' >
    <slot name='help-card-title' >{{ title }}</slot>
  </v-card-title>

  <v-card-text class='text-h5 px-10'>
  <slot name='help-card-text' >
    <p v-if='description' v-text="description" />
    <ul class='font-weight-light' >
      <li class='py-2' v-for='item in listitems' :key='item' v-text='item' />
    </ul>
  </slot>
  </v-card-text>

  <v-card-actions class='px-10' >
    <slot name='help-card-actions' >
      <v-spacer/>
      <v-btn @click='$emit("done")' color='primary' class='px-5' large >{{ ctaText }}</v-btn>
    </slot>
  </v-card-actions>
</v-card>
</template>
<script>
export default {
  name: 'HelpCard',
  props: {
    title: { type: String },
    description: { type: String },
    ctaText: { type: String, default: 'Let\'s go!' },
    listitems: { type: Array, default: () => { return [] } }
  }
}
</script>
